// Calibre dark theme — matches prototype design
export const COLORS = {
  // Backgrounds
  bg: "#0f1419",
  surface: "#1a1f26",
  surfaceAlt: "#242b35",
  surfaceHover: "#2d3640",

  // Borders
  border: "#2f3942",
  borderLight: "#363f4a",

  // Text
  text: "#e7e9ea",
  textSecondary: "#9ca3af",
  textMuted: "#6b7280",

  // Accent / brand
  accent: "#3b82f6",
  accentLight: "#1e3a5f",
  accentHover: "#2563eb",

  // Status colors
  green: "#22c55e",
  greenLight: "#14532d",
  orange: "#fbbf24",
  orangeLight: "#422006",
  red: "#ef4444",
  redLight: "#450a0a",
  purple: "#a78bfa",
  purpleLight: "#2e1065",

  // Score-specific
  scoreHigh: "#22c55e",
  scoreMid: "#fbbf24",
  scoreLow: "#ef4444",
};
